import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import "./quantity-selector.scss";
export class QuantitySelector extends MithrilTsxComponent {
    inputValue;
    inputPending = false;
    view(v) {
        const current = this.inputPending ? this.inputValue : (v.attrs.value ?? 0);
        const setValue = (val, evt) => {
            const safe = isNaN(val) ? 0 : Math.max(v.attrs.min ?? 0, val);
            v.attrs[`on${evt}`]?.(safe);
            if (evt === "change") {
                delete this.inputValue;
                delete this.inputPending;
            }
            else
                this.inputValue = safe;
        };
        return (m("div", { className: "quantity-selector-container" },
            m("div", { className: "quantity-selector" },
                m("button", { className: current <= (v.attrs.min ?? 0) ? "quantity-btn -disabled" : "quantity-btn", onclick: () => setValue(current - 1, "change") },
                    m("span", null, "-")),
                m("input", { type: "number", className: "quantity-input", value: current, oninput: (e) => {
                        this.inputPending = true;
                        let value = parseInt(e.target.value);
                        if (isNaN(value)) {
                            delete this.inputValue;
                            return;
                        }
                        setValue(value, "input");
                    }, onchange: (e) => {
                        let value = parseInt(e.target.value);
                        if (isNaN(value))
                            value = v.attrs.min ?? 0;
                        setValue(value, "change");
                    } }),
                m("button", { className: "quantity-btn", onclick: () => setValue(current + 1, "change") },
                    m("span", null, "+")))));
    }
    onbeforeupdate(v, o) {
        if (v.attrs.value !== o.attrs.value)
            delete this.inputValue;
    }
}
